$(document).ready(function () {
    $('#size-picker-button').click(function () {
        $('#size-options').slideToggle();
        // Toggle the rotate-icon class based on the current state
        $(this).find('.icon-caret').toggleClass('rotate-icon');

        // Slide up engraving element when size picker is toggled
        if ($('#size-options').is(':visible')) {
            $('.engraving__wrapper--item--engraving-text-hidden').slideUp();
            $('.item__engraving--js').removeClass('active').addClass('inactive');
            $('.item__no-engraving--js').removeClass('inactive').addClass('active');
        }
    });

    $('.size-radiobutton').change(function () {
        var selectedSize = $(this).val();
        window.selectedSize = selectedSize;
        $('#size-picker-button .button-text').text('Size: ' + selectedSize); // Update only the text part
        $('#size-options').slideUp();
        // Remove the rotate-icon class when options are closed
        $('#size-picker-button').find('.icon-caret').removeClass('rotate-icon');
    });

    // Set the default size to 6 when the page loads
    var defaultSize = '6';
    $('input[name="properties[Size]"][value="' + defaultSize + '"]').prop('checked', true);
    $('#size-picker-button .button-text').text('Size: ' + defaultSize);
});